import { FC, ReactNode } from 'react';
import { Tooltip } from '@/components/ui/Tooltip';

interface BadgeProps {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'gray' | 'outline';
  size?: 'sm' | 'md';
  className?: string;
  icon?: FC<{ className?: string }>;
  tooltip?: string;
}

export const Badge: FC<BadgeProps> = ({
  children,
  variant = 'gray',
  size = 'md',
  className = '',
  icon: Icon,
  tooltip,
}) => {
  const variants = {
    primary: 'bg-lime-100 text-lime-800',
    secondary: 'bg-blue-100 text-blue-800',
    success: 'bg-green-100 text-green-800',
    warning: 'bg-yellow-100 text-yellow-800',
    error: 'bg-red-100 text-red-800',
    gray: 'bg-gray-100 text-gray-600',
    outline: 'bg-transparent text-gray-600',
  };

  const sizes = {
    sm: 'px-2 py-0.5 stat-label',
    md: 'px-3 py-1 stat-label',
  };

  const content = (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-bold transition-all ${variants[variant]} ${sizes[size]} ${className}`}
    >
      {Icon && <Icon className={size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5'} />}
      {children}
    </span>
  );

  if (tooltip) {
    return <Tooltip content={tooltip}>{content}</Tooltip>;
  }

  return content;
};
